import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pwa-banner"
}
const _hoisted_2 = ["src"]

import { ref, onMounted, onUnmounted } from 'vue'
import Swal from 'sweetalert2'
import { useLogo } from '@/composables/useLogo'

const DISMISSED_KEY = 'pwa_install_dismissed'


export default /*@__PURE__*/_defineComponent({
  __name: 'PwaInstallBanner',
  setup(__props) {

const { logoUrl } = useLogo()
const visible = ref(false)
let deferredPrompt: any = null

function canShow(): boolean {
  const dismissed = localStorage.getItem(DISMISSED_KEY)
  if (dismissed) {
    // Show again after 7 days
    const daysSince = (Date.now() - parseInt(dismissed)) / 86400000
    if (daysSince < 7) return false
  }
  const standalone =
    (window.navigator as any).standalone === true ||
    window.matchMedia('(display-mode: standalone)').matches
  return !standalone
}

function onBeforeInstall(e: Event) {
  e.preventDefault()
  deferredPrompt = e
  if (canShow()) visible.value = true
}

async function install() {
  if (deferredPrompt) {
    deferredPrompt.prompt()
    const { outcome } = await deferredPrompt.userChoice
    deferredPrompt = null
    if (outcome === 'accepted') visible.value = false
  } else {
    // Fallback: iOS manual instructions
    Swal.fire({ title: 'Instalar no iOS', text: 'Toque no botão Compartilhar (⎋) e selecione "Adicionar à Tela de Início"', icon: 'info' })
    dismiss()
  }
}

function dismiss() {
  visible.value = false
  localStorage.setItem(DISMISSED_KEY, String(Date.now()))
}

onMounted(() => {
  window.addEventListener('beforeinstallprompt', onBeforeInstall)
  // iOS doesn't fire beforeinstallprompt — show generic banner after a delay
  setTimeout(() => {
    const isIos = /iPhone|iPad|iPod/i.test(navigator.userAgent)
    if (isIos && canShow() && !deferredPrompt) visible.value = true
  }, 3000)
})

onUnmounted(() => {
  window.removeEventListener('beforeinstallprompt', onBeforeInstall)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "pwa-slide" }, {
      default: _withCtx(() => [
        (visible.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("img", {
                src: _unref(logoUrl),
                class: "pwa-logo",
                alt: "ISBET"
              }, null, 8, _hoisted_2),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "pwa-text" }, [
                _createElementVNode("strong", null, "Instalar ISBET Dashboard"),
                _createElementVNode("span", null, "Adicione um atalho na tela inicial")
              ], -1)),
              _createElementVNode("button", {
                class: "pwa-btn-install",
                onClick: install
              }, "Instalar"),
              _createElementVNode("button", {
                class: "pwa-btn-close",
                onClick: dismiss,
                title: "Fechar"
              }, [...(_cache[0] || (_cache[0] = [
                _createElementVNode("svg", {
                  width: "14",
                  height: "14",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  _createElementVNode("line", {
                    x1: "18",
                    y1: "6",
                    x2: "6",
                    y2: "18"
                  }),
                  _createElementVNode("line", {
                    x1: "6",
                    y1: "6",
                    x2: "18",
                    y2: "18"
                  })
                ], -1)
              ]))])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})